import styled from 'styled-components';

const Arrow = ({ width = 22, height = 12, title = 'arrow', ...props }) => (
  <svg width={width} height={height} {...props}>
    <title>{title}</title>
    <path d="M0,6 L22,6" stroke="#F88143" strokeWidth="2" />
    <path d="M21,6 L16,0" stroke="#F88143" strokeWidth="2" />
    <path d="M21,6 L16,12" stroke="#F88143" strokeWidth="2" />
  </svg>
);

export default styled(Arrow)``;
